<template>
  <div class="help-edit-btns-box">
    <div class="left">
      <span v-if="dataset.scheduled_release_time">发布时间：该内容将于 {{dataset.scheduled_release_time ? timeRest(dataset.scheduled_release_time) : ''}} 发布</span>
    </div>
    <div class="right">
      <div class="send-time" v-if="release_status === 2 && !isHasSend">
        <el-date-picker
          v-model="scheduled_release_time"
          ref="time"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          popper-class="wf-picker-panel help-edit-btns-date"
          type="datetime"
          :picker-options="pickerOptions"
          placeholder="选择日期时间">
        </el-date-picker>
        <wf-button plain @click="selectTime" :disabled="isDisabled">{{scheduled_release_time ? scheduled_release_time.replace(/-/g, '/') : '选择发布时间'}}</wf-button>
      </div>
      <wf-button @click="save" plain v-if="!isHasSend" :disabled="isDisabled">保存为草稿</wf-button>
      <wf-button @click="reviews" plain :disabled="isDisabled">预览</wf-button>
      <el-button-group>
        <wf-button @click="send" :disabled="isDisabled">{{isHasSend && release_status === 2 ? '取消发布' : labelList.label}}</wf-button>
        <el-dropdown trigger="click" @visible-change="visibleChange" @command="command" :disabled="isDisabled">
          <wf-button @click="showReviews" :disabled="isDisabled">
            <i class="icon iconfont iconicon_arrow_task_1" :class="{'rota90': show}"></i>
          </wf-button>
          <el-dropdown-menu slot="dropdown" class="help-edit-btns-menu">
            <el-dropdown-item v-for="item in list" :key="item.release_status" :command="item">{{item.label}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-button-group>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  props: ['dataset', 'isDisabled'],
  data() {
    return {
      release_status: 3,
      scheduled_release_time: '',
      show: false,
      pickerOptions: {
        selectableRange:'00:00:00 - 23:59:59',
        disabledDate(time) {
          var date = new Date();
          date.setFullYear(date.getFullYear()+2);
          date.setDate(date.getDate()-1);
          return (time.getTime() < Date.now() - 8.64e7)||(time.getTime()>date.getTime());
        }
      },
      option: [{
        release_status: 2,
        label: '定时发布'
      }, {
        release_status: 3,
        label: '发布'
      }],
      isHasSend: false
    }
  },
  watch: {
    scheduled_release_time() {
      this.selectable()
    }
  },
  computed: {
    list() {
      let idx = this.option.findIndex(res => res.release_status === this.release_status)
      let arr = JSON.parse(JSON.stringify(this.option))
      arr.splice(idx, 1)
      return arr
    },
    labelList() {
      return this.option.find(res => res.release_status === this.release_status) || {}
    }
  },
  mounted() {
    this.scheduled_release_time = this.dataset.scheduled_release_time
    this.release_status = this.dataset.release_status === 1 ? 3 : this.dataset.release_status
    this.isHasSend = this.release_status === 2
  },
  methods: {
    selectable() {
        const date = moment(this.scheduled_release_time).startOf('day').format('x');
        const nowDate = moment().startOf('day').format('x');
        // 如果选择的是今天 则需要禁用已经过去的时间节点
        if (date <= nowDate) {
            // 默认选择的最新时间 是当前时间的1分钟后
            this.pickerOptions.selectableRange = (
                `${moment().add(1, 'minutes').format('HH:mm:ss')} - 23:59:59`
            );
        }
        // 如果是以后的日期，则不需要禁用时间节点
        else {
            this.pickerOptions.selectableRange = '00:00:00 - 23:59:59';
        }
    },
    showReviews() {

    },
    visibleChange(val) {
      this.show = val
    },
    selectTime() {
      this.$refs.time.handleFocus()
    },
    command(val) {
      this.release_status = val.release_status
    },
    reviews() {
      this.$emit('reviews', this.dataset)
    },
    save() {
      this.$emit('save')
    },
    async send() {
      if(this.isHasSend) {
        await this.$wfAlert('', `确认取消发布该内容？`)
        this.$emit('cancelSend', {id: this.dataset.id, release_status: 1, scheduled_release_time: ''})
      } else {
        if(this.release_status === 3) { // 直接点击发布
          if(this.dataset.released_records_count > 0) { // 是否第一次发布
            await this.$wfAlert('', `确定对"${this.dataset.title}"进行重新发布？`)
          } else {
            await this.$wfAlert('', `确认发布该内容？`)
          }
        }
        this.$emit('send', {id: this.dataset.id, release_status: this.release_status, scheduled_release_time: this.scheduled_release_time})
      }
    }
  }
}
</script>
<style lang="scss">
.help-edit-btns-date {
  padding-bottom: 0;
  .el-button--text.el-picker-panel__link-btn {
      display: none;
  }
}
.help-edit-btns-menu {
  padding: 0;
  margin-bottom: 8px !important;
  width: 90px;
}
.help-edit-btns-box {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  background-color: #fff;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  border-top: 1px solid rgba(32,32,32,0.08);
  .right {
    display: flex;
    align-items: center;
    &> * {
      margin-left: 24px;
    }
    .el-button-group {
      display: flex;
      align-items: center;
      .wf-button:first-child {
        border-radius: 4px 0 0 4px;
      }
      .el-dropdown {
        .wf-button {
          border-radius: 0 4px 4px 0;
          padding: 0 7px;
          i {
            font-size: 14px;
            font-weight: 400;
            transition: all .3s;
          }
        }
        .wf-button-content {
          height: 100%;
        }
      }
    }
    .send-time {
      position: relative;
      .el-date-editor {
        position: absolute;
        z-index: -999;
        visibility: hidden;
      }
    }
  }
  .left {
    display: flex;
    align-items: center;
    span {
      color: rgba(32, 32, 32, 0.6);
      font-size: 14px;
    }
  }
}
</style>
